/**
 * Numbers in the admin panel (DESIGN-V3): a comma between thousands and a decimal point, as the v3
 * design writes them (12,480; 48.2K; 2.5%). `en-ZA` mixes a space for thousands with a decimal
 * comma ("48,2K"), so every count, figure and percentage goes through these helpers.
 */
const LOCALE = 'en-GB';

const integer = new Intl.NumberFormat(LOCALE);
// en-US: "48.2K" everywhere (en-GB writes "48.2k" in some ICU versions, "48.2K" in others).
const compact = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

/** `12480` → `12,480`. */
export function formatNumber(value: number): string {
  return integer.format(value);
}

/** `48210` → `48.2K`, `146200` → `146K`. */
export function formatCompact(value: number): string {
  return compact.format(value);
}

/** `2.48` → `2.5%` (the value is already a percentage). */
export function formatPercent(value: number, digits = 1): string {
  return `${value.toFixed(digits)}%`;
}
